/// <amd-module name="Search/Package/Flux/Sources/PackageSearchSource" />

import * as Rest_Client from "Search/WebApi/RestClient/Search";
import { IVssPageContext } from "VSS/Platform/Context";
import { PackageSearchResponse, PackageSearchRequest } from "Search/WebApi/Contracts/Search.Shared";
import { SearchSourceType } from "Search/Shared/Base/Sources/SearchSource";
import { IVssPageService, IPageData } from "VSS/Platform/Page";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { getTimestamp } from "Search/Shared/Base/Telemetry";

const PACKAGE_SEARCH_PAGE_DATAPROVIDER_CONTRIBUTION_ID = "ms.vss-package-search.package-search-page-viewmodel-data-provider";

export interface ISearchSourceResponse {
    responseWithActivityId: PackageSearchResponse | undefined;

    source: SearchSourceType;
}

export class PackageSearchSource {
    private readonly packageSearchRestClient: Rest_Client.ISearchRestClient;
    private useDataProvider: boolean;
    private pageData: IPageData | undefined;

    constructor(
        isTabSwtich: boolean,
        private readonly pageContext: IVssPageContext) {
        this.packageSearchRestClient = this.pageContext.getRestClient<Rest_Client.ISearchRestClient>("ISearchRestClient");
        this.useDataProvider = !isTabSwtich;
        this.pageData = this.pageContext.getService<IVssPageService>("IVssPageService").getData();
    }

    public getPackageSearchResults(
        request: PackageSearchRequest,
        onSuccess: (response: ISearchSourceResponse) => void,
        onFailure: ({ error, activityId }: any) => void): void {
        if (this.useDataProvider) {
            const dataProviderContributionId = this.pageData!.isHosted
                ? PACKAGE_SEARCH_PAGE_DATAPROVIDER_CONTRIBUTION_ID
                : PACKAGE_SEARCH_PAGE_DATAPROVIDER_CONTRIBUTION_ID;

            const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
            const startTime = getTimestamp();

            const responseWithActivityId: PackageSearchResponse | undefined = contributionService.getData(dataProviderContributionId);
            this.useDataProvider = false;

            const telemetryService = this.pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
            telemetryService.publishEvent(
                "search.V2Page",
                "PackageSearchWebPageDataServiceResolution",
                {
                    E2ETimeInMs: getTimestamp() - startTime
                });

            if (responseWithActivityId && responseWithActivityId.content) {
                onSuccess({ responseWithActivityId, source: SearchSourceType.DataProvider });
                return;
            }
        }

        this.packageSearchRestClient
            .fetchPackageSearchResults(request)
            .then(responseWithActivityId => {
                onSuccess({ responseWithActivityId, source: SearchSourceType.RestApi });
            }, error => {
                onFailure({ error, activityId: this.pageData && this.pageData.sessionId });
            });
    }
}